import { useLenis } from "lenis/react";
import { DISCORD_URL, NAV_LINKS } from "../../lib/site";
import { useI18n } from "../../i18n/LanguageContext";
import { DiscordIcon } from "./DiscordIcon";

export const Footer = () => {
  const { t } = useI18n();
  const lenis = useLenis();
  const scrollTo = (href) =>
    lenis ? lenis.scrollTo(href, { offset: -80 }) : document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="border-t border-white/5 py-12 px-5 md:px-8" data-testid="footer">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="h-9 w-9 rounded-lg bg-brand grid place-items-center font-display font-extrabold text-[#080a0f]">M</span>
          <span className="font-display font-bold tracking-tight">MShop</span>
        </div>
        <nav className="flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              data-testid={`footer-nav-${l.href.replace("#", "")}`}
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              {t.nav[l.key]}
            </button>
          ))}
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-discord"
            className="text-sm text-cyan-400 hover:text-cyan-300 transition-colors inline-flex items-center gap-2"
          >
            <DiscordIcon className="h-4 w-4" /> {t.common.discord}
          </a>
        </nav>
        <p className="text-xs text-slate-600 font-mono">© {new Date().getFullYear()} MShop — {t.footer.copyright}</p>
      </div>
    </footer>
  );
};
